import { render, staticRenderFns } from "./PaymentForm.vue?vue&type=template&id=2bad6fbe&scoped=true"
import script from "./PaymentForm.vue?vue&type=script&lang=js"
export * from "./PaymentForm.vue?vue&type=script&lang=js"
import style0 from "./PaymentForm.vue?vue&type=style&index=0&id=2bad6fbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bad6fbe",
  null
  
)

export default component.exports